/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Layout from '../../../../components/layout/Layout';
import FilterSidebar from '../../../../components/FilterSidebar';
import ReportTab from './tabs/ReportTab';
import ReportFilter, { DATA_MODE_ASSETS_OR_DIVISIONS, DATE_MODE_RANGE } from '../../ReportFilter';

const { REPORT_TYPES } = require('../../../../core/constants').default;

export default function () {
    const { eventsTabLoaded, eventsTabFilter, filterSidebar, filters } = this.state;
    const { user, isFetching } = this.props;

    return (
        <Layout
            className="events"
            title={<div>Asset Odometer Report</div>}
            headerTitle={<div>Asset Odometer Report</div>}
            loading={isFetching}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar displayFilter={filterSidebar}>
                    <ReportFilter
                        onSubmit={this.onEventsTabFilterChange}
                        filters={filters}
                        dataMode={DATA_MODE_ASSETS_OR_DIVISIONS}
                        dateMode={DATE_MODE_RANGE}
                        reportType={REPORT_TYPES.find((rt) => rt.link === 'asset-odometer-report').link}
                    />
                </FilterSidebar>
                <div 
                    className="content"
                    style={{ opacity: isFetching ? 0 : 1 }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <div className="section__body">
                                <div className="section__action-bar" />
                                <ReportTab
                                    toggleFilterSidebar={() => this.setState({ filterSidebar: !filterSidebar })}
                                    eventsTabFilter={eventsTabFilter}
                                    setLoadedState={this.eventsTabLoaded}
                                    eventsTabLoaded={eventsTabLoaded}
                                    reportHasBeenFetched={this.state.reportHasBeenFetched}
                                />
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
